export enum EmailServices {
    GMAIL = 'Gmail',
    OUTLOOK = 'Outlook',
    YAHOO = 'Yahoo Mail',
}
